module.exports = __webpack_public_path__ + "img/visa-mobile-info_x1.946a6f47.png";